import styles from './contact-us.module.scss';
import texts from './contact-us.texts.json';
import { ContactForm } from './contact-form/contact-form';
import { useSubmitContactDetails } from '../../query-hooks/contact-us';
import { ContactFormSuccessMessage } from './contact-form-success-message/contact-form-success-message';
import { ContactFormErrorMessage } from './contact-form-error-message/contact-form-error-message';

export const ContactUs = () => {
  const {
    mutate: submitContactDetails,
    isLoading,
    isError,
    isSuccess,
  } = useSubmitContactDetails();

  if (isError) return <ContactFormErrorMessage />;

  if (isSuccess) return <ContactFormSuccessMessage />;

  return (
    <div className={styles.container}>
      <div className={styles.textBox}>
        <h2 className={styles.title}>{texts.leaveDetails}</h2>
        <p className={styles.description}>{texts.description}</p>
      </div>
      <ContactForm onSubmit={submitContactDetails} isLoading={isLoading} />
    </div>
  );
};
